var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{staticClass:"d-flex text-wrap text-break",attrs:{"color":"primary"},on:{"click":_vm.downloadTemplate}},[_vm._v(" Plantilla ")])
}
var staticRenderFns = []

export { render, staticRenderFns }